/**
 * Stylebay brand wordmark.
 * Uses the same serif family as headings (Playfair Display).
 * Color follows currentColor → adapts to light/dark backgrounds.
 */
export default function Brand({ size = "md", className = "" }) {
  const sizes = {
    xs: "text-base",
    sm: "text-lg",
    md: "text-xl",
    lg: "text-3xl",
    xl: "text-5xl",
    "2xl": "text-6xl",
  };
  return (
    <span
      className={`stylebay-brand inline-block leading-none ${sizes[size] || sizes.md} ${className}`}
      aria-label="Stylebay"
    >
      Style<span className="stylebay-brand-b">B</span>ay
    </span>
  );
}
